import { MAIL_OUTBOX_PAGE_INTRO } from "../mailOutboxPage.constants";

export function MailOutboxIntro() {
  return <p className="mb-6 text-sm text-muted-foreground">{MAIL_OUTBOX_PAGE_INTRO}</p>;
}
